import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-down-step",
  "use": "icon-arrow-down-step-usage",
  "viewBox": "0 0 33 18",
  "content": "<symbol viewBox=\"0 0 33 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-down-step\">\n<rect y=\"13.786\" width=\"33\" height=\"3.82946\" fill=\"#999999\" />\n<path d=\"M16.5 0V12.2543M16.5 12.2543L23.65 7.27597M16.5 12.2543L9.35001 7.27597\" stroke=\"#999999\" stroke-width=\"4\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol